import { AUDIT_PROGRESS } from './audit'

const SECTIONS = {
  van_external_images: 'van_external_images',
  daily_validator: 'daily_validator',
  tread_work_shoe: 'tread_work_shoe',
  completed: AUDIT_PROGRESS.completed,
}

const TIME_ISSUES = {
  completedLate: 'Completed after 10AM',
}

const VAN_ISSUES = {
  incorrectVan: 'Incorrect Van',
  damageIdentified: 'Damage Identified - needs review',
}

const DAILY_VALIDATOR_ISSUES = {
  unableToReadScreen: 'Unable to Read Screen',
  wrongPhoto: 'Wrong Photo',
  redLight: 'Red Light',
  broken: 'Broken',
  outOfCalibration: 'Out of Calibration (±10%)',
  noPhoto: 'No Photo / Black Photo',
}

const TREAD_WORK_SHOE_DEFECTS = {
  no: 'No',
  needsReplacement: 'Needs Replacement',
}

const SECTIONS_ORDER = {
  [SECTIONS.van_external_images]: SECTIONS.daily_validator,
  [SECTIONS.daily_validator]: SECTIONS.tread_work_shoe,
  [SECTIONS.tread_work_shoe]: SECTIONS.completed,
}

const TITLES = {
  [SECTIONS.van_external_images]: 'DVIR Van',
  [SECTIONS.daily_validator]: 'Daily Validator',
  [SECTIONS.tread_work_shoe]: 'Tread Work Shoe',
}

const QUESTIONS = {
  [SECTIONS.van_external_images]: 'Exterior photos.',
  [SECTIONS.daily_validator]:
    'Did the technician record a pass of the Mountz validator?',
  [SECTIONS.tread_work_shoe]:
    'Does the technician have on slip resistant shoes? (Note: this picture was recently added and some technicians may not be prompted to daily take this picture yet)',
}

export {
  TIME_ISSUES,
  VAN_ISSUES,
  DAILY_VALIDATOR_ISSUES,
  QUESTIONS,
  SECTIONS,
  SECTIONS_ORDER,
  TITLES,
  TREAD_WORK_SHOE_DEFECTS,
}
